import configureStore from "./configureStore";

const { store, persistor } = configureStore();

export { persistor, store as default };
